// import "@babel/polyfill";
import BrowserDetect from "./BrowserDetect";
import Responsive from "./Responsive";
import SmoothScroll from "./SmoothScroll";
// import Accordion from './Accordion';
// import Tab from './Tab';
import SpNavi from "./SpNavi";
import ToTop from "./ToTop";
// import DropDownMenu from './DropDownMenu';
// import BlockLink from './BlockLink';
// import Gmap from './Gmap';
import matchheight from 'jquery-match-height';
// import link_icon from './link_icon';
// import Swiper from "swiper";
import Swiper from "swiper/dist/js/swiper.min.js";
import inview from "jquery-inview";
import { tweenMax, timeLineMax, TimelineMax } from "gsap";
import remodal from "remodal";
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on("resize", function() {
// //check is responsive;
// console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target: "#spnavi",
	trigger: ".btn_sp_navi",
	filter: "resposive_flg",
	speed: 200,
};
const spnavi = new SpNavi(param);
// spnavi.exec();

// ナビたちをsp用にclone
$(".btn_sp_navi").on("click.addNav", function () {
	let targets = [
		".p-globalNav",
		".l-globalHeader_mark",
		".p-submenuWrapper",
		".p-utilityNav",
	];
	targets.forEach(function (e) {
		$(e).clone().appendTo("#scroller");
	});
	$(".btn_sp_navi").off("click.addNav");
});

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
let spnav_accordion_1 = (scroller) => {
	$("#scroller .menu-item-has-children").off();
	$("#scroller .menu-item-has-children > a").on("click", function (e) {
		e.preventDefault();
		$(this).parent().toggleClass("is-active");
		$(this)
			.next(".sub-menu")
			.stop()
			.slideToggle(200, function () {
				scroller.refresh();
			});
	});

	// $('#scroller .inner > ul > li > span').off();
	// $('#scroller .inner > ul > li > span').on('click',function(){
	// 	let $parent = $(this).parent('li');
	// 	let $child = $(this).next('.gnavi-child');
	// 	let status = $child.css('display');

	// 	if(status == 'block'){
	// 		$child.slideUp(300,function(){
	// 			scroller.refresh();
	// 		});
	// 		$parent.removeClass('active');
	// 	}else{
	// 		$child.slideDown(300,function(){
	// 			scroller.refresh();
	// 		});
	// 		$parent.addClass('active');
	// 	}

	// 	return false;
	// });
};
spnavi.exec(spnav_accordion_1);
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop(".c-totop", ".js-totop-threshold", 100, 400, true, 30);
totop.exec();
totop.clear_fixed_position();

const bnrSpecial = new ToTop(
	".p-bnrSpecial",
	".js-totop-threshold",
	100,
	400,
	true,
	100
);
bnrSpecial.exec();
bnrSpecial.clear_fixed_position();

/* ===============================================
top page main visual slider
=============================================== */
const heroMainSlide = new Swiper(".js-heroMainSlide", {
	speed: 800,
	autoplay: {
		delay: 5000,
	},
	effect: "fade",
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

let heroSubSlide = new Swiper(".js-heroSubSlide", {
	direction: "vertical",
	spaceBetween: 10,
	slidesPerView: 'auto',
	slidesPerGroup: 1,
	autoHeight: true,
	allowTouchMove: false,
	breakpoints: {
		768: {
			direction: "horizontal",
			loop: true,
			allowTouchMove: true,
			speed: 800,
			slidesPerView: 2,
			spaceBetween: 0,
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		},
	},
});
$(window).on(
	"resize",
	_.throttle(function () {
		if ($(".js-heroSubSlide").length) {
			if (r.state()()) {
				heroSubSlide.params.direction = "vertical";
			} else {
				heroSubSlide.params.direction = "horizontal";
			}
			let prm = heroSubSlide.params;
			heroSubSlide.destroy(true, true);
			heroSubSlide = new Swiper(".js-heroSubSlide", prm);
		}
	}, 400)
);
/* ===============================================
sp toggle search box
=============================================== */
$(".js-btn-sp-search").on("click", function () {
	$(".p-searchBox").toggle();
	$(this).toggleClass("is-active");
});

/* ===============================================
home main anim
=============================================== */
$(".js-sectionHeader-anim").each(function () {
	const _this = $(this);
	const target = {
		title: _this.find(".js-sectionHeader_title"),
		flag: _this.find(".js-sectionHeader_flag"),
	};
	_this.on("inview", function () {
		const tl = new TimelineMax({
			paused: false,
			onComplete: function () {
				_this.addClass("is-animated");
			},
		});
		tl.to(target.title, 0.3, { className: "+=is-active" }, 0.2);
		tl.to(target.flag, 0.3, { className: "+=is-active" }, 0.4);
		tl.to(_this, 0.3, { className: "+=is-active" }, 0.6);
	});
});

// const animTarget = document.querySelectorAll(".js-sectionHeader-anim");
// const observer = new IntersectionObserver(entries => {
// 	if (entries[0].isIntersecting) {
// 		const targetParent = entries[0].target;
// 		const targetElement = {
// 			title: targetParent.querySelector(".js-sectionHeader_title"),
// 			flag: targetParent.querySelector(".js-sectionHeader_flag")
// 		};
// 		const tl = new TimelineMax({
// 			paused: false,
// 			onComplete: function() {
// 				targetParent.classList.add("is-animated");
// 			}
// 		});
// 		tl.to(targetElement.title, 0.3, { className: "+=is-active" }, 0.2);
// 		tl.to(targetElement.flag, 0.3, { className: "+=is-active" }, 0.4);
// 		tl.to(targetParent, 0.3, { className: "+=is-active" }, 0.6);
// 	}
// });

// // for (let i = 0; i < animTarget.length; i++) {
// // 	observer.observe(animTarget[i]);
// // }
// observer.observe(animTarget);

$(".js-toggle-eventList").on("click", function () {
	let target = $(".js-eventList-accordion");
	let btn = $(this);

	//sp時、アコーディオン展開時にスクロール
	const scrollToTarget = (target) => {
		let targetPosition = target.offset().top;
		if (!r.state()()) {
			$("html,body").animate({ scrollTop: targetPosition - 30 });
		}
	};
	if (target.hasClass("is-active")) {
		target.removeClass("is-active").slideUp();
		setTimeout(function () {
			btn.html("もっと見る").removeClass("mod-up").addClass("mod-down");
		}, 400);
	} else {
		target.slideDown().addClass("is-active");
		setTimeout(function () {
			btn.html("閉じる").removeClass("mod-down").addClass("mod-up");
		}, 400);
	}
	scrollToTarget(target); //sp時のみスクロール
});

/* ===============================================
from old template
=============================================== */
// < !--ポップアップ start-- >
$(function () {
	$(".popup").fancybox({});
});
$(function () {
	if ($(window).width() > 640) {
		$(".popupNews").fancybox({
			width: 700,
			height: 480,
			autoScale: false,
			transitionIn: "none",
			transitionOut: "none",
			type: "iframe",
			onComplete: function () {
				let winY = $(window).scrollTop();
				let innerH = window.innerHeight;
				console.log({ winY, innerH });
				$("#fancybox-wrap").css({
					top: winY + innerH / 2,
					transform: "translateY(-50%)",
				});
			},
		});
	}
});

/* ===============================================
single php
=============================================== */
let ua = navigator.userAgent.toLowerCase();
// iPhone
let isiPhone = ua.indexOf("iphone") > -1;
// iPad
let isiPad = ua.indexOf("ipad") > -1;
// Android
let isAndroid = ua.indexOf("android") > -1 && ua.indexOf("mobile") > -1;
// Android Tablet
let isAndroidTablet = ua.indexOf("android") > -1 && ua.indexOf("mobile") == -1;

// 使用例

if (isiPhone || isiPad || isAndroid || isAndroidTablet) {
	$(".js-btn-sp").css({ display: "block" });
} else {
	$(".js-btn-sp").css({ display: "none" });
}

/* ===============================================
single slider
=============================================== */
const editorSlide = new Swiper(".js-editorSlide", {
	speed: 800,
	autoplay: {
		delay: 5000,
	},
	effect: "fade",
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	// autoHeight: true
});
const editorSlideFast = new Swiper(".js-editorSlide-fast", {
	speed: 800,
	autoplay: {
		delay: 1000,
	},
	effect: "fade",
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	// autoHeight: true
});
/* ===============================================
check browser
=============================================== */
const browserDetect = new BrowserDetect();

/* ===============================================
gnav
=============================================== */
const subMenu = $(".l-globalHeader .sub-menu");
subMenu.each((index, elem) => {
	const child = $(elem).find("li");
	const childLength = child.length;
	if (childLength > 7) {
		$(elem).addClass('mod-child-9')
	}
});
/* ===============================================
matchheight
=============================================== */
let matchHeightTarget = $('.p-careerCont._2col.mod-careerMessage').find('.matchheight');
$(function() {
	if(matchHeightTarget.length > 0) {
		matchHeightTarget.matchHeight();
	}
});
/* ===============================================
トップページのDOM移動
=============================================== */
const moveFunc = () => {
	if (window.innerWidth > 768) {
		const moveElement = document.querySelector(".p-hero_subCol");
		const moveTarget = document.querySelector(".p-hero_mainCol");
		const container = document.querySelector(".p-hero_inner");
		if (!moveElement || !moveTarget || !container) return;
		moveTarget.parentNode.insertBefore(moveElement, moveTarget.nextSibling)
 	} else {
		const moveElement = document.querySelector(".p-hero_subCol");
		const moveTarget = document.querySelector(".p-sectionHome");
		const container = document.querySelector(".p-hero_mainCol");
		if (!moveElement || !moveTarget || !container) return;
		container.insertBefore(moveElement, moveTarget);
	}
  };

// 初回読み込み時にmoveFunc関数を実行する
window.addEventListener('DOMContentLoaded', moveFunc);

// resizeイベント発生時にmoveFunc関数を実行する
window.addEventListener("resize", moveFunc);
/* ===============================================
スクロール中のLINEボタンの処理
=============================================== */
let isScrolling = false;
function whileScrolling() {
	document.querySelector('.js-scrollTarget').classList.add('is-active')
}
function afterScrolling() {
	document.querySelector('.js-scrollTarget').classList.remove('is-active')
}
window.addEventListener("scroll", () => {
    isScrolling = true;

    clearTimeout(scrollTimeout);
    const scrollTimeout = setTimeout(() => {
        isScrolling = false;
        afterScrolling();
    }, 2000);
    whileScrolling();
});